module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABeSURBVHgB1ZCxDYAwDAQPlDqDMAGDMEjmYQLmoWAPAi08RoISSDpykgtLPst+eGGRhlUK5GJiYzUWLjtrOkH7JdoMFUw7hChFt5FODf5a4pOl+9Q558+fSyeWXv8kHXY2bZ0IHsPGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/y.png
// module id = b/Pk
// module chunks = 1